import Crud from '../views/Tripulante/Crud'
import Entity from '../views/Tripulante/Add'

let routes = {
    path: '/tripulantes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tripulantes/add',
            name: 'Newtripulante',
            component: Entity
        },
        {
            path: '/tripulantes/edit/:id?',
            name: 'Edittripulante',
            component: Entity
        },
        {
            path: '/tripulantes',
            name: 'list-tripulantes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tripulantes',
                breadcrumb: [
                    {
                        text: 'Tripulantes',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
